export default __webpack_public_path__ + "static/media/a028-example3.24288dbe.jpg";